import CMSPage from "@/components/CMSPage";
import { Calculator } from "lucide-react";

export default function MortgageCalculatorPage() {
  return (
    <CMSPage
      pageId="mortgage-calculator"
      defaultTitle="Mortgage Calculator"
      defaultDescription="Calculate your monthly mortgage payments and affordability. Enter your property price, deposit, and interest rate to get an instant estimate."
      icon={Calculator}
    />
  );
}
